import { ScheduledFreeShippingThreshold, Variant } from '__generated__/graphql';
import { isNotNullish } from 'utils/isNotNullish';
import { getScheduledFreeShippingThreshold } from 'utils/scheduledFreeShipping';

export const hasVariantFreeShipping = (
  variation: Variant | null | undefined,
  freeShippingThreshold: number | null | undefined,
  scheduledFreeShipping?: {
    scheduledThresholds?: ScheduledFreeShippingThreshold[] | null | undefined;
    dateToCheck?: Date;
  }
) => {
  if (!isNotNullish(variation) || !isNotNullish(freeShippingThreshold)) {
    return false;
  }
  const { salePrice, price } = variation.productPrice || {};
  const priceToCheck = isNotNullish(salePrice) ? salePrice : price;

  if (!isNotNullish(priceToCheck)) return false;

  const currentScheduledFreeShippingThreshold =
    getScheduledFreeShippingThreshold(scheduledFreeShipping);

  const thresholdToCheck =
    currentScheduledFreeShippingThreshold ?? freeShippingThreshold;

  return priceToCheck > 0 && priceToCheck >= thresholdToCheck;
};
